import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Profiles from "../data/Profiles.json";
import getProfile from "../utils/getProfile";

class Interested extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      profile: getProfile(props.quiz.questions),
      selectedIndex: props.quizResult.selectedIndex,
    };
  }

  breakLine(text) {
    return text.replace(/(<br \/>)/g, "\r\n ");
  }

  textFormater(text_array) {
    let formated_text = text_array.map((item) => {
      let array_new = [];
      item = item.toString().replace(/(<nb\/>)/g, "\r\n ");
      array_new.push(item);
      return array_new;
    });

    formated_text = formated_text.toString().replace(/(\.,)/g, "\r\n\r\n");
    return formated_text;
  }

  goalsLink(profile_goals) {
    const links = [
      "",
      "poverty/",
      "hunger/",
      "health/",
      "education/",
      "gender-equality/",
      "water-and-sanitation/",
      "energy/",
      "economic-growth/",
      "infrastructure-industrialization/",
      "inequality/",
      "cities/",
      "sustainable-consumption-production/",
      "climate-change-2/",
      "oceans/",
      "biodiversity/",
      "peace-justice/",
      "globalpartnerships/",
    ];

    const goals_and_links = profile_goals
      .map((element) => {
        const goal_number = element.split(" ")[0];
        const link_goal = `${element}: https://www.un.org/sustainabledevelopment/${links[goal_number]}`;
        return link_goal;
      })
      .toString()
      .replace(/(\/,)/g, "\r\n");
    return goals_and_links;
  }

  render() {
    /* Storing profile text */
    const short_profile = Profiles.profiles[this.state.profile];
    const sProfileText_text_title_1 = short_profile.text_title_1;
    const sProfileText_text_title_2 = short_profile.text_title_2;
    const sProfileText_text_1 = this.breakLine(short_profile.text_1);
    const sProfileText_text_2 = this.textFormater(short_profile.text_2);
    const sProfileText_text_3 = this.textFormater(short_profile.text_3);
    const sProfileText_text_4 = this.textFormater(short_profile.text_4);
    const sProfile_goals = this.goalsLink(short_profile.goals);

    const personal_development_point =
      Profiles.sustainableFocus[this.state.profile.slice(1, 3)][
        this.state.selectedIndex
      ];

    const style = {
      margin: {
        marginBottom: "20px",
      },
      alignment: {
        textAlign: "left",
      },
    };

    function SendLinkByMail(href) {
      var subject = "Your personal profile and personal development point";
      var body = "Thank you for playing the game! \r\n";
      body += "Your personal profile is:  \r\n\r\n";
      body += sProfileText_text_title_1 + "\r\n";
      body += sProfileText_text_title_2 + "\r\n";
      body += sProfileText_text_1;

      body += "\r\n\r\n Ecological integrity \r\n\r\n";
      body += sProfileText_text_2;

      body += "\r\n\r\n Social and economic justice \r\n\r\n";
      body += sProfileText_text_3;

      body += "\r\n\r\n Democracy, nonviolence and peace \r\n\r\n";
      body += sProfileText_text_4;

      body += "\r\n\r\n Goals \r\n\r\n";
      body += sProfile_goals;

      body += " \r\n\r\n";

      var str3 = personal_development_point;
      body += "Your personal development point is: " + str3;
      body += " \r\n\r\n\r\n------\rKind regards,\r\nSustainable team";
      var uri = "mailto:?subject=";
      uri += encodeURIComponent(subject);
      uri += "&body=";
      uri += encodeURIComponent(body);
      window.open(uri);
    }

    return (
      <section>
        <div>
          <div className="container">
            <Typography
              variant="headline"
              style={{ fontSize: "20px", marginTop: "15px" }}
            >
              Share
            </Typography>
            <Typography style={style.margin} component="div">
              Your personal profile and personal development point with your
              friend, colleague or yourself by mail
            </Typography>
            <Button
              variant="raised"
              style={{ marginBottom: "20px" }}
              color="primary"
            >
              <a style={{ color: "white" }} onClick={() => SendLinkByMail()}>
                Share now
              </a>
            </Button>

            <Typography
              variant="headline"
              style={{ fontSize: "20px", marginTop: "15px" }}
            >
              Personal Challenge
            </Typography>
            <Typography style={style.margin} component="div">
              <ul style={style.alignment}>
                <li>
                  Please visit the following link:{" "}
                  <a
                    href="https://showyourtruecolours.nl/licentie-spelen-show-your-true-colors/?lang=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <br />
                    Get to know your team profile
                  </a>
                </li>
              </ul>
            </Typography>
            <Link to={"/thankyou"}>
              <Button variant="raised" style={style.margin} color="primary">
                Done
              </Button>
            </Link>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ quiz, quizResult }) => ({ quiz, quizResult });
export default connect(mapStateToProps)(Interested);



// WEBPACK FOOTER //
// ./src/views/InterestView.jsx